import React from "react";
import "./Projects.css";

const Projects = () => {
  const projects = [
    {
      title: "Subdomain Enumeration Tool",
      category: "Reconnaissance",
      difficulty: "Intermediate",
      featured: true,
      description:
        "A fast and lightweight Python tool for discovering subdomains using passive techniques such as Certificate Transparency logs (crt.sh) with optional brute-force support.",
      impact:
        "Efficient reconnaissance tool for bug bounty workflows, capable of discovering numerous subdomains quickly.",
      technologies: [
        "Python",
        "Requests",
        "crt.sh API",
        "Multithreading",
        "JSON",
      ],
      image: "/images/project/Subdomain_Enumeration.png",
      links: {
        github: "https://github.com/7ima-SR/Subdomain_Enumeration",
      },
    },
    {
      title: "Web Brute Forcer (DVWA Tested)",
      category: "Web Security",
      difficulty: "Intermediate",
      featured: true,
      description:
        "A Python-based login brute force tool capable of handling CSRF tokens and session cookies. Tested against DVWA at low and medium security levels.",
      impact:
        "Simulates real-world authentication attack scenarios and demonstrates understanding of CSRF handling and session management.",
      technologies: [
        "Python",
        "Requests",
        "Session Handling",
        "CSRF Token Extraction",
        "HTML Parsing",
      ],
      image: "/images/project/Brute_Forcer2.png",
      links: {
        github: "https://github.com/7ima-SR/Brute_Forcer",
      },
    },
    {
      title: "Custom ICMP Ping Sweeper",
      category: "Network Security",
      difficulty: "Intermediate",
      featured: true,
      description:
        "A Python-based ICMP network scanner built with Scapy to scan IP ranges and detect live hosts using crafted ICMP Echo Requests.",
      impact:
        "Demonstrates low-level packet crafting and practical internal network reconnaissance techniques.",
      technologies: [
        "Python",
        "Scapy",
        "ICMP",
        "Packet Crafting",
        "Network Scanning",
      ],
      image: "/images/project/Custom_Ping_Sweeper_ICMP2.png",
      links: {
        github: "https://github.com/7ima-SR/Custom_Ping_Sweeper_ICMP",
      },
    },
    {
      title: "Web Spider & Link Extractor",
      category: "Automation",
      difficulty: "Intermediate",
      featured: true,
      description:
        "A Python-based web crawler that extracts links from websites up to a specified depth with export support in TXT and JSON formats.",
      impact:
        "Useful for reconnaissance automation and structured data extraction in security testing workflows.",
      technologies: [
        "Python",
        "Requests",
        "BeautifulSoup",
        "Crawling",
        "Data Extraction",
      ],
      image: "/images/project/Web_Spider.png",
      links: {
        github: "https://github.com/7ima-SR/Web_Spider",
      },
    },
  ];

  return (
    <section id="projects" className="projects-section">
      <div className="projects-container">
        <h2 className="section-title">Featured Projects</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-overlay">
                  <div className="overlay-info">
                    <span className="project-category">{project.category}</span>
                    <span className="project-difficulty">{project.difficulty}</span>
                  </div>
                  <div className="project-links">
                    <a
                      href={project.links.github}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Source Code
                    </a>
                  </div>
                </div>
              </div>
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <p className="project-impact"><em>{project.impact}</em></p>
                <div className="project-tech">
                  {project.technologies.map((tech, techIndex) => (
                    <span key={techIndex} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
